
import React from 'react'
import Box from './Box'

/**
 * Resizer component.
 */

export default function Resizer({ toggle, position, expanded = false, ...props }) {
  if (!position) throw new Error(`Resizer position required`)
  
  const classes = [
    position,
    toggle && 'toggle',
    expanded && 'expanded',
  ]
  
  return <Box
    className="Resizer"
    classes={classes}
    {...props}
  />
}